import { render, staticRenderFns } from "./CuponHeaderDetails.vue?vue&type=template&id=71a9f4dc&scoped=true&"
import script from "./CuponHeaderDetails.vue?vue&type=script&lang=js&"
export * from "./CuponHeaderDetails.vue?vue&type=script&lang=js&"
import style0 from "./CuponHeaderDetails.vue?vue&type=style&index=0&id=71a9f4dc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a9f4dc",
  null
  
)

export default component.exports